import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/home/Home'
import City from '@/pages/city/City'
import Major from '@/pages/major/Index'
import Detail from '@/pages/detail/Index'
import documentDetail from '@/pages/documentDetail/Index'
import News from '@/pages/news/Index'
import TeachPlan from '@/pages/teachplan/Index'
import PersonalCenters from '@/pages/PersonalCenters/Index'
import DegreeModule from '@/pages/PersonalCenters/DegreeModuleIndex'
import GraduationManagement from '@/pages/graduationmanagement/Index'
import ChangeState from '@/pages/PersonalCenters/components/ChangeState'
import ForgetPassword from '@/pages/PersonalCenters/components/ForgetPassword'
import FeedBack from '@/pages/PersonalCenters/components/feedBack'
import getStuPhoto from '@/pages/PersonalCenters/components/getStuPhoto'
import applyOfflineExam from '@/pages/PersonalCenters/components/ApplyOfflineExamV2'
import degreeApplication from '@/pages/PersonalCenters/components/degreeApplication'
import ExamPaperList from '@/pages/PersonalCenters/components/ExamPaperList'
import MyInfo from '@/pages/PersonalCenters/components/MyInfo'
import DegreeInfo from '@/pages/PersonalCenters/components/DegreeInfo'
import Payment from '@/pages/PersonalCenters/components/Payment'
import orderPay from '@/pages/PersonalCenters/components/orderPay'
import RegistrationCheck from '@/pages/PersonalCenters/components/RegistrationCheck'
import StartSchool from '@/pages/PersonalCenters/components/StartSchool'
import StartState from '@/pages/PersonalCenters/components/StartState'
import InformationAcquisition from '@/pages/PersonalCenters/components/InformationAcquisition'
import RegistrationForm from '@/pages/PersonalCenters/components/RegistrationForm'
import fileStorage from '../pages/PersonalCenters/components/fileStorage.vue'
import myPersonalStudyFee from '@/pages/PersonalCenters/components/myPersonalStudyFee'
import ViewTrack from '@/pages/PersonalCenters/components/ViewTrack'
import ViewStatus from '@/pages/PersonalCenters/components/ViewStatus'
import ChangeStatefirst from '@/pages/PersonalCenters/components/ChangeStatefirst'
import ExamPost from '@/pages/PersonalCenters/components/ExamPost'
import MyScore from '@/pages/myscore/Index'
import ScoreDetail from '@/pages/scoredetail/Index'
import Examination from '@/pages/examination/Index'
import MyClass from '@/pages/myclass/Index'
import CourseSelection from '@/pages/courseselection/Index'
import LoginIndex from '@/pages/LoginIndex/Index'
import zuaLoginIndex from '@/pages/LoginIndex/zuaLoginIndex'

import EmbeddedWeather from '@/pages/city/EmbeddedWeather'

import quickLogin from '@/pages/LoginIndex/quickLogin'
import hnlgLogin from '@/pages/LoginIndex/hnlgLogin'
import teachNet from '@/pages/LoginIndex/teachNet'
import goTextbookOrder from "@/pages/LoginIndex/goTextbookOrder";
import DistanceLearning from "@/pages/distancelearning/Index";
import DefenseRoomList from "@/pages/defenseOnline/Index";
import ExaminationRecord from "@/pages/examinationrecord/Index";
import SubmissionRecords from "@/pages/submissionrecords/Index";
import Info from "@/pages/info/Index";
import Notice from "@/pages/notice/Index";
import FindPwd from "@/pages/findpwd/Index";
import UserBind from "@/pages/userbind/Index";
import ChangeStateFirst from "@/pages/graduationmanagement/components/ChangeStatefirst";
import ChangeStateFirsttopic from "@/pages/graduationmanagement/components/ChangeStateFirsttopic";
import ChangeStateSecond from "@/pages/graduationmanagement/components/ChangeStateSecond";
import ChangeStateThird from "@/pages/graduationmanagement/components/ChangeStateThird";
import ChangeStateFourth from "@/pages/graduationmanagement/components/ChangeStateFourth";
import ChangeStateFifth from "@/pages/graduationmanagement/components/ChangeStateFifth";
import SecuritySetting from "@/pages/PersonalCenters/components/SecuritySetting";
import SecuritySettingtab1 from "@/pages/PersonalCenters/components/SecuritySettingtab1";
import SecuritySettingtab2 from "@/pages/PersonalCenters/components/SecuritySettingtab2";
import SecuritySettingtab3 from "@/pages/PersonalCenters/components/SecuritySettingtab3";
import GraduateApply from "@/pages/PersonalCenters/components/GraduateApply";
import textbookOrder from "@/pages/textbookOrder/index";
import Shell from "@/pages/shell/shell";
import offlineteach from "@/pages/offlineteach/Index";
import documentItem from "@/pages/documentItem/index";
import todoList from "@/pages/todos/index";
import todoDetail from "@/pages/todos/detail";
import todosList from "@/pages/todos/todoList";
import todoItem from "@/pages/todos/todoItem";
import CreditBank from "@/pages/creditBank/index";
import CreditApplication from "@/pages/creditBank/CreditApplication";
import TuitionPayment from "@/pages/tuitionPayment/index";
import GraduatonCondition from "@/pages/graduatonCondition/index";

// 实践课
import PracticeDetail from '@/pages/PracticeDetail/PracticeDetailIndex' // 实践课详情页面--内部使用
import PracticeDetailOut from '@/pages/PracticeDetail/PracticeDetailOutIndex' // 实践课详情页面--外部系统调用

// 信息采集
import InfoCollectProject from '@/pages/PersonalCenters/components/CollectProjectList' // 信息采集项目列表-内部使用
import InfoCollectProjectOut from '@/pages/PersonalCenters/components/CollectProjectListOut' // 信息采集项目列表-外部调用
import CollectNoticeIndex from '@/pages/infocollect/CollectNoticeIndex' // 信息采集--采集须知
import FillInformation from '@/pages/infocollect/FillInformation' // 信息采集--信息填报
import PreviewInfo from '@/pages/infocollect/PreviewInfo' // 信息采集--信息阅览
import PreRegistration from '@/pages/preRegistration/index' // 预报名
// 文档中心
import documentCenter from '@/pages/documentcenter/index' // 文档中心列表--内部使用
import documentList from '@/pages/documentList/index'
import tduckForm from '../pages/tduckForm/index.vue' // 文档中心列表--外部系统调用

import QRCodeLoginResult from '@/pages/QRCodeLoginResult/index' // 微信二维码登录 结果页
import Cookies from 'js-cookie'

import { initTheme } from '../assets/styles/themeServe'
import ErrorIndex from '@/pages/errorTips/index' // 错误提示页
import { isPC } from '@/utils/device.js'

Vue.use(Router)

const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}
const router = new Router({
  routes: [
    {
      path: '/EmbeddedWeather',
      name: 'EmbeddedWeather',
      component: EmbeddedWeather,
    },
    {
      path: '/',
      name: 'shell',
      component: Shell,
      redirect: '/home',
      children: [
        {
          path: '/home',
          name: 'Home',
          component: Home,
        },
        {
          path: '/city',
          name: 'City',
          component: City,
        },
        {
          path: '/detail/:id',
          name: 'Detail',
          component: Detail,
        },
        {
          path: '/documentdetail/:id',
          name: 'documentDetail',
          component: documentDetail,
        },
        {
          path: '/practicedetail',
          name: 'PracticeDetail',
          component: PracticeDetail,
        },
        {
          path: '/practicedetailout',
          name: 'PracticeDetailOut',
          component: PracticeDetailOut,
        },
        {
          path: '/major',
          name: 'Major',
          component: Major,
        },
        {
          path: '/teachplan',
          name: 'TeachPlan',
          component: TeachPlan,
        },
        {
          path: '/examination',
          name: 'Examination',
          component: Examination,
        },
        {
          path: '/info',
          name: 'Info',
          component: Info,
        },
        {
          path: '/examinationrecord',
          name: 'ExaminationRecord',
          component: ExaminationRecord,
        },
        {
          path: '/submissionrecords',
          name: 'SubmissionRecords',
          component: SubmissionRecords,
        },
        {
          path: '/distancelearning',
          name: 'DistanceLearning',
          component: DistanceLearning,
        },
         {
          path: '/defenseOnline',
          name: 'DefenseOnline',
          component: DefenseRoomList,
        },
        {
          path: '/textbookorder',
          name: 'textbookOrder',
          component: textbookOrder,
        },
        {
          path: '/QRCodeLoginResult',
          name: 'QRCodeLoginResult',
          component: QRCodeLoginResult,
        },
        {
          path: '/documentcenter',
          name: 'documentCenter',
          component: documentCenter,
        },
        {
          path: '/documentList',
          name: 'documentList',
          component: documentList,
        },
        {
          path: '/documentItem/:id',
          name: 'documentItem',
          component: documentItem,
        },
        {
          path: '/offlineteach',
          name: 'offlineteach',
          component: offlineteach,
        },
        {
          path: '/myclass',
          name: 'MyClass',
          component: MyClass,
        },
        {
          path: '/news',
          name: 'News',
          component: News,
        },
        {
          path: '/myscore',
          name: 'MyScore',
          component: MyScore,
        },
        {
          path: '/courseselection',
          name: 'CourseSelection',
          component: CourseSelection,
        },
        {
          path: '/scoredetail/:id',
          name: 'ScoreDetail',
          component: ScoreDetail,
        },
        {
          path: '/notice',
          name: 'notice',
          component: Notice,
        },
        {
          path: '/personalcenters',
          name: 'PersonalCenters',
          component: PersonalCenters,
          children: [
            {
              path: '/personalcenters/infocollect',
              name: 'InfoCollectProject',
              component: InfoCollectProject,
            },
            {
              path: '/personalcenters/changestate',
              name: 'ChangeState ',
              component: ChangeState,
            },
            {
              path: '/personalcenters/examPost',
              name: 'ExamPost',
              component: ExamPost,
            },
            {
              path: "/graduation/apply",
              name: "graduationApply",
              component: GraduateApply
            },
            {
              path: "/personalcenters/forgetpassword",
              name: "ForgetPassword ",
              component: ForgetPassword,
            },
            {
              path: '/personalcenters/myinfo',
              name: 'MyInfo',
              component: MyInfo,
            },
            {
              path: '/personalcenters/payment',
              name: 'Payment',
              component: Payment,
            },
            {
              path: '/personalcenters/orderpay',
              name: 'orderPay',
              component: orderPay,
            },
            {
              path: '/personalcenters/StartSchool',
              name: 'StartSchool',
              component: StartSchool,
            },
            {
              path: '/personalcenters/informationacquisition',
              name: 'InformationAcquisition',
              component: InformationAcquisition,
            },
            {
              path: '/personalcenters/startstate',
              name: 'StartState',
              component: StartState,
            },
            {
              path: '/personalcenters/RegistrationCheck',
              name: 'RegistrationCheck',
              component: RegistrationCheck,
            },
            {
              path: '/personalcenters/registrationform',
              name: 'RegistrationForm',
              component: RegistrationForm,
            },
            {
              path: '/mypersonal/tuitionfeethis',
              name: 'myPersonalStudyFee',
              component: myPersonalStudyFee,
            },
            {
              path: '/personalcenters/viewtrack',
              name: 'ViewTrack',
              component: ViewTrack,
            },
            {
              path: '/personalcenters/viewstatus',
              name: 'ViewStatus',
              component: ViewStatus,
            },
            {
              path: '/personalcenters/changestatefirst',
              name: 'ChangeStatefirst',
              component: ChangeStatefirst,
            },
            {
              path: '/personalcenters/securitysetting',
              name: 'SecuritySetting',
              component: SecuritySetting,
            },
            {
              path: '/personalcenters/securitysettingtab1',
              name: 'SecuritySettingtab1',
              component: SecuritySettingtab1,
            },
            {
              path: '/personalcenters/securitysettingtab2',
              name: 'SecuritySettingtab2',
              component: SecuritySettingtab2,
            },
            {
              path: '/personalcenters/securitysettingtab3',
              name: 'SecuritySettingtab3',
              component: SecuritySettingtab3,
            },
            {
              path: '/personalcenters/FeedBack',
              name: 'FeedBack',
              component: FeedBack,
            },

            {
              path: '/personalcenters/getStuPhoto',
              name: 'getStuPhoto',
              component: getStuPhoto,
            },
            {
              path: '/personalcenters/applyOfflineExam',
              name: 'applyOfflineExam',
              component: applyOfflineExam,
            },
            {
              path: '/personalcenters/fileStorage',
              name: 'fileStorage',
              component: fileStorage,
            },
          ],
        },

        {
          path: '/degreemodule',
          name: 'DegreeModule',
          component: DegreeModule,
          children: [
            {
              path: '/degreemodule/degreeinfo',
              name: 'DegreeInfo',
              component: DegreeInfo,
            },
            {
              path: '/personalcenters/degreeApplication',
              name: 'degreeApplication',
              component: degreeApplication,
            },

            {
              path: '/personalcenters/exampaperlist',
              name: 'ExamPaperList',
              component: ExamPaperList,
            },
          ],
        },
        // 信息采集--外部调用
        {
          path: '/infocollect/project',
          name: 'InfoCollectProjectOut',
          component: InfoCollectProjectOut,
        },
        // 信息采集--填报须知
        {
          path: '/personalcenters/infocollectindex',
          name: 'CollectNoticeIndex',
          component: CollectNoticeIndex,
        },
        // 信息采集--信息预览
        {
          path: '/personalcenters/infocollect/fillInfo',
          name: 'FillInformation',
          component: FillInformation,
        },
        // 信息采集--信息预览
        {
          path: '/personalcenters/infocollect/previewInfo',
          name: 'PreviewInfo',
          component: PreviewInfo,
        },
        {
          path: '/graduationmanagement',
          name: 'GraduationManagement',
          component: GraduationManagement,
          redirect: '/graduationManagement/changestatefirst',
          children: [
            {
              path: '/graduationManagement/changestatefirst',
              name: 'ChangeStateFirst',
              component: ChangeStateFirst,
            },
            {
              path: '/graduationManagement/changestatefirsttopic',
              name: 'ChangeStateFirsttopic',
              component: ChangeStateFirsttopic,
            },
            {
              path: '/graduationManagement/changestatesecond',
              name: 'ChangeStateSecond',
              component: ChangeStateSecond,
            },
            {
              path: '/graduationManagement/changestatethird',
              name: 'ChangeStateThird',
              component: ChangeStateThird,
            },
            {
              path: '/graduationManagement/changestatefourth',
              name: 'ChangeStateFourth',
              component: ChangeStateFourth,
            },
            {
              path: '/graduationManagement/changestatefifth',
              name: 'ChangeStateFifth',
              component: ChangeStateFifth,
            },
          ],
        },
        {
          path: '/todos/list',
          name: 'todos-list',
          component: todoList,
        },
        {
          path: '/todos/detail',
          name: 'todos-detail',
          component: todoDetail,
        },
        {
          path: '/todolist',
          name: 'todolist',
          component: todosList,
        },
        {
          path: '/todoItem',
          name: 'todoitem',
          component: todoItem,
        },
        {
          path: '/creditBank',
          name: 'CreditBank',
          component: CreditBank,
        },
        {
          path: '/tduckForm',
          name: 'tduckForm',
          component: tduckForm,
        },
        {
          path: '/creditApplication',
          name: 'CreditApplication',
          component: CreditApplication,
        },
        {
          path: '/tuitionPayment',
          name: 'TuitionPayment',
          component: TuitionPayment,
        },
        {
          path: '/graduatonCondition',
          name: 'graduatonCondition',
          component: GraduatonCondition,
        },
      ],
    },
    {
      path: '/login',
      name: 'LoginIndex',
      component: LoginIndex,
    },
    {
      path: '/zuaLoginIndex',
      name: 'zuaLoginIndex',
      component: zuaLoginIndex,
    },
    {
      path: '/findpwd',
      name: 'FindPwd',
      component: FindPwd,
    },
    {
      path: '/userbind',
      name: 'UserBind',
      component: UserBind,
    },
    {
      path: '/quick/login',
      name: 'quickLogin',
      component: quickLogin,
    },
    {
      path: '/hnlg/login',
      name: 'hnlgLogin',
      component: hnlgLogin,
    },
    {
      path: '/teach/net',
      name: 'teachNet',
      component: teachNet,
    },
    {
      path: '/gotextbook/order',
      name: 'goTextbookOrder',
      component: goTextbookOrder,
    },
    {
      path: '/mypersonal/tuitionfee',
      name: 'myPersonalStudyFee',
      component: myPersonalStudyFee,
    },
    {
      path: '/preRegistration/index',
      name: 'preRegistration',
      component: PreRegistration,
    },
    {
      path: '/error',
      name: 'ErrorIndex',
      component: ErrorIndex,
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
})

const whiteList = [
  '/error',
  '/login',
  '/findpwd',
  '/quick/login',
  '/gotextbook/order',
  '/mypersonal/tuitionfee',
  '/personalcenters/forgetpassword',
  '/personalcenters/infocollectindex', // 信息采集
  '/personalcenters/infocollect/fillInfo', // 信息采集填报
  '/personalcenters/infocollect/previewInfo', // 信息采集预览
  '/todos/list',
  '/todos/detail',
  '/todolist',
  '/todoItem',
  '/hnlg/login',
  '/userbind',
  '/teach/net',
  '/preRegistration/index',
  '/QRCodeLoginResult', // 微信二维码登录结果页
  '/zuaLoginIndex',
  '/EmbeddedWeather',
]
let lastCacheValue = null // 保存上一次的缓存值
router.beforeEach(async (to, from, next) => {
  const currentValue = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).eduCode : ''

  // 只有当值存在且与上次不同时才执行方法
  if (currentValue !== null && currentValue !== lastCacheValue) {
    initTheme(currentValue)
    lastCacheValue = currentValue // 更新记录的值
  }

  if (to.path == '/error') {
    if (!isPC()) {
      next()
    } else {
      // PC浏览器访问错误页，跳转到首页
      next('/')
      return
    }
  } else {
    if (!isPC()) {
      // 非PC浏览器访问，跳转到错误提示页
      next('/error')
      return
    }
  }

  if (to.path == '/login' && Cookies.get('loginType') == 2) {
    next('/zuaLoginIndex')
  }
  if (whiteList.includes(to.path)) {
    next()
    return
  }
  try {
    const isPass = await Vue.prototype.axios.get(`/biz/home/mustDeal/check?url=${to.fullPath}`)
    if (isPass.result === 0) {
      next()
    } else {
      if (isPass.result === 1) {
        Vue.prototype.$message.error('您还有未处理的必办事项！')
      } else if (isPass.result === -1) {
        Vue.prototype.$message.error('请耐心等待代办审核完成！')
      }
      next('/todos/list')
    }
  } catch (error) {
    next('/login')
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js